export function isHomePagePath(pathname: string): boolean {
    return (
        pathname === '/'
        || pathname === '/home'
        || pathname === '/help/how-virtoly-works-expert'
        || pathname === '/help/how-virtoly-works-customer'
    );
}

export function dismissAppBootLoader(): void {
    document.getElementById('app-boot-loader')?.remove();
}
